import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { CircularProgress, makeStyles } from '@material-ui/core';
import LicenseCheck from 'LicenseCheck';
import { allowedIFrames } from 'store/helpers/helperFunctions';

const useStyles = makeStyles(theme => ({
    loader: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

const IFrameComponent = props => {
    const { editor, id } = useParams();
    const history = useHistory();
    const classes = useStyles();
    const licenses = LicenseCheck();
    const { isLicenseLoading, canAccessBasicOrStandard, canAccessPrint } = licenses;

    useEffect(() => {
        if(!isLicenseLoading) {
            let isIframeAuthorized = allowedIFrames().length > 0;
            if(isIframeAuthorized) {
                if(editor === 'unlayer') {
                    if(canAccessBasicOrStandard) {
                        history.push(`/unlayerEditor${id ? `/${id}` : ``}`);
                    } else {
                        history.push(`/not-authorized`);
                    }
                } else if(editor === 'unlayerAttachment') {
                    if(canAccessBasicOrStandard) {
                        history.push(`/unlayerAttachmentEditor${id ? `/${id}` : ``}`);
                    } else {
                        history.push(`/not-authorized`);
                    }
                } else if(editor === 'grapejs') {
                    if(canAccessPrint) {
                        history.push(`/grapejsEditor${id ? `/${id}` : ``}`);
                    } else {
                        history.push(`/not-authorized`);
                    }
                } else {
                    history.push(`/not-found`);
                }
            } else {
                history.push(`/not-authorized`);
            }
        }
    }, [isLicenseLoading]);
    return (
        <div className={classes.loader}>
            <CircularProgress />
        </div>
    )
}

export default IFrameComponent;